import React from 'react';

function AdminTabNavigation({ activeTab, onTabChange, counts = {} }) {
  const tabs = [
    { id: 'overview', label: 'Overview' },
    { id: 'users', label: 'Users' },
    { id: 'listings', label: 'Listings' },
    { id: 'requests', label: 'Requests' },
    { id: 'certificates', label: 'Certificates' },
    { id: 'verification', label: 'Cert. Verification' },
    { id: 'reports', label: 'Reports' },
    { id: 'content', label: 'Content' }
  ];

  return (
    <div className="border-b border-gray-200">
      <nav className="-mb-px flex space-x-6 overflow-x-auto" aria-label="Tabs">
        {tabs.map(tab => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${  
              activeTab === tab.id
                ? 'border-primary-500 text-primary-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            } flex items-center`}
          >
            {tab.label}
            {tab.id === 'verification' && counts.pendingCertificates > 0 && (
              <span className="ml-1.5 px-2 py-0.5 text-xs font-medium rounded-full bg-yellow-100 text-yellow-800">
                {counts.pendingCertificates}
              </span>
            )}
          </button>
        ))}
      </nav>
    </div>
  );
}

export default AdminTabNavigation;
